import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Custom Angular `TitleStrategy` that builds the browser tab title using
 * the `title` field declared on each route, falling back to the application
 * name when no route-level title exists.
 *
 * Format: `${routeTitle} | ${APP_NAME}` or `${APP_NAME}` when missing.
 *
 * For dynamic detail pages (e.g. `/contacts/:id`) the route declares a
 * generic title (`Contact`), and the detail component overrides the title
 * with the loaded entity name through `Title.setTitle(...)` once the data
 * arrives.
 */
@Injectable({ providedIn: 'root' })
export class EwentsTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private static readonly APP_NAME = 'Ewents CRM';

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot);
    this.title.setTitle(
      routeTitle ? `${routeTitle} | ${EwentsTitleStrategy.APP_NAME}` : EwentsTitleStrategy.APP_NAME
    );
  }
}
